import { render, staticRenderFns } from "./ChatPrivateVideo.vue?vue&type=template&id=f021ea82"
import script from "./ChatPrivateVideo.vue?vue&type=script&lang=js"
export * from "./ChatPrivateVideo.vue?vue&type=script&lang=js"
import style0 from "./ChatPrivateVideo.vue?vue&type=style&index=0&id=f021ea82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports